import moment from "moment";

export const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null) {
        if (isNaN(row[id])) {
            return (
                row[id] !== undefined ?
                    String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
                    :
                    true
            );
        } else {
            return (
                row[id] !== undefined ?
                    String(row[id]).startsWith(filter.value)
                    :
                    true
            );
        }
    }
};

export const csvReader = (data) => {
    let csvData = {}
    let csvDataArray = []
    for (let i = 1; i <= data.length - 1; i++) {
        let csvRow = data[i]
        if (csvRow.length === data[0].length) {
            let csvData = Object.assign({}, csvData)
            csvRow.map((rowValue, j) => {
                csvData[data[0][j]] = rowValue
            })
            csvDataArray.push(csvData)
        }
    }
    return csvDataArray;
};

export const getRendomNumber = (length) => {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const formatDateNew = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
    }).format(amount);
};

export const formatDateLatest = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    });
};


const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

export const InitalDateFn = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

export const reverseFormat = (date) => {
  var d = date.split("-");

  return [d[2], d[1], d[0]].join("-");
};

export const todayDate = () => {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("-");
};

export const getStartDateOfPreviousSevenDays = (date) => {
    return moment(date).subtract(6, 'days').startOf('day').format('DD-MM-YYYY');
};

